import React from 'react'
import _ from 'lodash'
import PropTypes from 'prop-types'
import { Cell } from 'fixed-data-table-2'
import classnames from 'classnames/bind'
import { formatters } from '../../../utils'
import DataTableUtils from '../utils'
import styles from '../styles.scss'
const cx = classnames.bind(styles)

const { formatPercentage } = formatters

// Most likely this function will expand as more number use cases pop up in our grids. For now, using it to format percentages.
const renderValue = (value, { maximumFractionDigits, withSymbol }) =>
  formatPercentage(value, maximumFractionDigits, withSymbol)

const NumberCell = props => {
  const { rowIndex, definition, data, ...restProps } = props
  const { field } = definition
  const baseField = field.substring(field.lastIndexOf('.') + 1)
  const row = data[rowIndex]

  return (
    <Cell
      data-elm-id={`${baseField}_${rowIndex}_cell`}
      className={cx('cell')}
      {...restProps}
    >
      <div
        data-elm-id={`${baseField}_${rowIndex}_value`}
        style={{ width: DataTableUtils.getCellInnerWidth(definition.colProps) }}
        className={cx('text-truncate')}
      >
        {renderValue(
          _.get(row, field) || row[baseField],
          definition.formatOptions || {}
        )}
      </div>
    </Cell>
  )
}

/**
 * formatOptions for NumberCell allow for digit length formatting and percentage symbol display.
 * e.g. formatOptions: {
 *  maximumFractionDigits: 1,
 *  withSymbol: true,
 * }
 */

NumberCell.propTypes = {
  rowIndex: PropTypes.number,
  definition: PropTypes.shape({
    colProps: PropTypes.object.isRequired,
    field: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    formatOptions: PropTypes.shape({
      maximumFractionDigits: PropTypes.number,
      withSymbol: PropTypes.bool,
    }),
  }).isRequired,
  data: PropTypes.array,
}

export default NumberCell
